var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.87,
    d: "M9.416.25h-7.5C1.091.25.424.925.424 1.75l-.008 12 5.25-2.25 5.25 2.25v-12c0-.825-.675-1.5-1.5-1.5m0 11.25-3.75-1.635-3.75 1.635V1.75h7.5z"
  })));
};
export default SvgBookmark;